
import {
	IonContent,
	IonHeader,
	IonPage,
	loadingController,
	alertController,
	IonInput,
	IonImg,
	IonLabel,
	IonButton,
	IonCard,
	IonGrid,
	IonRow,
	IonCol,
	isPlatform,
} from "@ionic/vue";
import { defineComponent, ref } from "vue";
import { store } from "../store";
import localStore from "../utils/localstore";
import { ActionTypes as Auth } from "../store/modules/auth";
// import { Storage } from "@ionic/storage";
import Navbar from "../components/Navbar.vue";
import { logoApple, logoFacebook, logoGoogle } from "ionicons/icons";

export default defineComponent({
	name: "Login",
	components: {
		IonContent,
		IonHeader,
		IonPage,
		Navbar,
		IonInput,
		IonImg,
		IonLabel,
		IonButton,
		IonCard,
		IonGrid,
		IonRow,
		IonCol,
	},

	data() {
		return {
			email: "",
			password: "",
			itemData: {},
			logoApple,
			logoFacebook,
			logoGoogle,
		};
	},

	methods: {
		async login() {
			const payload = {
				email: this.email,
				password: this.password,
				store: localStore,
			};
			const loading = await loadingController.create({
				message: "Please wait...",
			});
			await loading.present();

			store
				.dispatch(Auth.loginUser, payload)
				.then(() => {
					loading.dismiss();
					const isSubscribed =
						store.getters.userProfile.subscription.isSubscribed;
					if (isSubscribed) {
						if (isPlatform("mobile") || isPlatform("mobileweb")) {
							this.$router.replace("/classes");
						} else {
							this.$router.replace("/");
						}
					} else {
						this.$router.replace("/subscribe");
					}
				})
				.catch(async (error) => {
					loading.dismiss();
					const alert = await alertController.create({
						header: "Login Failed",
						message: error.message,
						buttons: ["OK"],
					});
					alert.present();
				});
		},
		async googleAuth() {
			const loading = await loadingController.create({
				message: "Please wait...",
			});
			await loading.present();

			await store
				.dispatch(Auth.googleAuth, null)
				.then(() => {
					loading.dismiss();

					const isSubscribed =
						store.getters.userProfile?.subscription?.isSubscribed;

					if (isSubscribed) {
						console.log("HERE");
						if (isPlatform("mobile") || isPlatform("mobileweb")) {
							this.$router.replace("/classes");
						} else {
							this.$router.replace("/");
						}
					} else {
						this.$router.replace("/subscribe");
					}
				})
				.catch(async (error) => {
					loading.dismiss();
					const alert = await alertController.create({
						header: "Google Login Failed",
						message: error.message,
						buttons: ["OK"],
					});
					alert.present();
				});
		},

		async socialAuth(provider: string) {
			const loading = await loadingController.create({
				message: "Please wait...",
			});
			await loading.present();

			const payload = {
				provider,
				store: localStore,
			};

			await store
				.dispatch(Auth.socialAuth, payload)
				.then(() => {
					loading.dismiss();

					const isSubscribed =
						store.getters.userProfile?.subscription?.isSubscribed;

					if (isSubscribed) {
						if (isPlatform("mobile") || isPlatform("mobileweb")) {
							this.$router.replace("/classes");
						} else {
							this.$router.replace("/");
						}
					} else {
						this.$router.replace("/subscribe");
					}
				})
				.catch(async (error) => {
					loading.dismiss();
					const alert = await alertController.create({
						header: "Login Failed",
						message: error.message,
						buttons: ["OK"],
					});
					alert.present();
				});
		},
	},
	computed: {
		client() {
			return store.getters.client;
		},
	},
	setup() {
		let isWeb = false;
		if (isPlatform("mobile") || isPlatform("mobileweb")) {
			isWeb = false;
		} else {
			isWeb = true;
		}
		const isAndroid = isPlatform("android") && !isPlatform("mobileweb");
		const isIOS = isPlatform("ios") && !isPlatform("mobileweb");

		return {
			isAndroid,
			isIOS,
			isWeb,
		};
	},
});
